import { createContext, useContext } from 'react';
import type { CountryScope } from './api';

export interface CountryCtxValue {
  scope: CountryScope;
  setScope: (s: CountryScope) => void;
}

export const CountryCtx = createContext<CountryCtxValue>({ scope: 'all', setScope: () => {} });
export const useCountry = (): CountryCtxValue => useContext(CountryCtx);

export const SCOPE_LABEL: Record<CountryScope, string> = {
  all: 'All',
  jordan: 'Jordan',
  iraq: 'Iraq',
};
